import { Permission } from "@/lib/permissions/Permission.enum";
import useUserTokenStore from "@/stores/user-token.store";
import { permissionMap } from "./permissionMap";

// Wrapper component to use inline in JSX
export const PermissionGate: React.FC<{
  allOf?: Permission[];
  oneOf?: Permission[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}> = ({ allOf, oneOf, fallback = null, children }) => {
  const { permissions } = useUserTokenStore();

  const hasAll =
    !allOf || allOf.every((p) => permissions.includes(permissionMap[p]));
  const hasOne =
    !oneOf || oneOf.some((p) => permissions.includes(permissionMap[p]));
  const hasPermission = hasAll && hasOne;

  if (!hasPermission) return <>{fallback}</>;
  return <>{children}</>;
};
